import axios from "axios";

const getAuthToken = () => {
  return localStorage.getItem("token") ?? "";
};

const axiosInstance = axios.create({
  // baseURL: "http://localhost:8000",
  baseURL: "https://ergonistor-be-production.up.railway.app",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default axiosInstance;
